<template>
  <div class="@container">
    <router-link
      v-if="user"
      :to="{ name: 'WebUser', params: { username: user.username } }"
      class="flex flex-wrap items-center justify-between w-full p-2 gap-2 text-left border border-gray-300 rounded-lg shadow-xs group bg-white/80 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
      <span class="flex flex-1 items-center space-x-3 min-w-0">
        <div class="relative">
          <UserAvatar :user="user" size="xl" />
        </div>

        <span class="block flex-1 min-w-0 select-none">
          <span
            v-if="user.displayname"
            class="block text-sm font-medium text-gray-900 truncate"
            >{{ user.displayname }}</span
          >
          <span
            class="block font-medium truncate"
            :class="
              !user.displayname
                ? 'text-gray-900 text-sm lg:text-base'
                : 'text-gray-600 text-xs lg:text-sm'
            "
            >@{{ user.username }}</span
          >
          <div
            v-if="user?.reviews?.length"
            class="flex flex-row gap-2 justify-start w-full">
            <span class="text-xs font-medium text-black/70">
              {{ user.reviews[0].count }}
              {{ user.reviews[0].count === 1 ? 'review' : 'reviews' }}
            </span>
          </div>
        </span>
      </span>
      <template v-if="isCurrentUser">
        <span
          class="inline-flex items-center justify-center px-3 py-2 text-xs font-semibold text-gray-400 @xs:w-auto w-full @xs:shrink-0 shrink"
          >(this is you)</span
        >
      </template>
      <div v-else class="@xs:w-24 @xs:shrink-0 w-full shrink">
        <FollowButton
          :user="user"
          variant="default"
          size="sm" />
      </div>
    </router-link>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStoreAuth } from '@/stores/storeAuth'
import UserAvatar from '@/components/UserAvatar.vue'
import FollowButton from '@/components/Pure/FollowButton.vue'

const props = defineProps({
  user: Object
})

const storeAuth = useStoreAuth()

const isCurrentUser = computed(() => {
  const thisUserId = props.user?.user_id
  const currentUserId = storeAuth.user?.id
  return thisUserId && currentUserId && thisUserId === currentUserId
})
</script>

<style scoped>
.spectra_list_card {
  background-color: rgb(0, 0, 0);
  background-image:
    radial-gradient(at 10% 90%, rgb(137, 91, 245) 0px, transparent 50%),
    radial-gradient(at 60% 10%, rgb(61, 132, 245) 0px, transparent 50%),
    radial-gradient(at 90% 30%, rgb(34, 195, 93) 0px, transparent 50%),
    radial-gradient(at 70% 80%, rgb(249, 116, 21) 0px, transparent 50%),
    radial-gradient(at 20% 40%, rgb(231, 176, 8) 0px, transparent 50%),
    radial-gradient(at 40% 70%, rgb(236, 70, 153) 0px, transparent 50%),
    radial-gradient(at 85% 15%, rgb(238, 68, 68) 0px, transparent 50%);
}
</style>
